import type { FC } from "react";

import { LegalDisclaimer as UiLegalDisclaimer } from "@jti/ui/components/LegalDisclaimer";

import type { legalDisclaimerInputs } from "./LegalDisclaimer.builder";

type LegalDisclaimerBuilderProps = BuilderComponentProps<typeof legalDisclaimerInputs>;

export const LegalDisclaimer: FC<LegalDisclaimerBuilderProps> = ({ title, description, linkLabel, href }) => {
  return <UiLegalDisclaimer title={title} description={description} linkLabel={linkLabel} href={href} />;
};
